export default "__VITE_ASSET__68e5fd71__$_?nuxt_component=async&nuxt_component_name=SvgoFloorplanFirstFloor__"